import ProduitGenerationNormeController from './produit.generation.norme.controller';

export default {
    template: require('./produit.generation.norme.html'),
    controller: ProduitGenerationNormeController
};
